export default __webpack_public_path__ + "static/media/zombie.9875117c.webp";